/**
 * Linhas da lista "Minha organização" do cross-org: cabeçalho por organização seguido dos
 * chamados dela, organizações em ordem pt-BR.
 *
 * O servidor devolve o `total` da consulta inteira, não por organização, e a página tem
 * PAGE_SIZE itens. Quando a página não cobre todos os resultados, a contagem do cabeçalho é
 * só desta página, e o rótulo diz isso (spec 2026-09-27-chamados-revisao-geral §7).
 */
export type LinhaDaLista<T> =
  | { type: 'header'; org: string; rotulo: string }
  | { type: 'item'; item: T }

export function agruparPorOrganizacao<T extends { organization_name?: string | null }>(
  items: T[],
  total: number,
): LinhaDaLista<T>[] {
  const paginaCobreTudo = total <= items.length
  const porOrg = new Map<string, T[]>()
  for (const it of items) {
    const org = it.organization_name ?? 'Sem organização'
    const lista = porOrg.get(org) ?? []
    lista.push(it)
    porOrg.set(org, lista)
  }
  const out: LinhaDaLista<T>[] = []
  for (const [org, lista] of [...porOrg.entries()].sort((a, b) => a[0].localeCompare(b[0], 'pt-BR'))) {
    out.push({ type: 'header', org, rotulo: paginaCobreTudo ? String(lista.length) : `${lista.length} nesta página` })
    for (const item of lista) out.push({ type: 'item', item })
  }
  return out
}
